<div id="media-button-container" class="app-background" (click)="openDebug()" [ngClass]="{'gps-problems': AS.gpsProblems}">
  <div class="single-button" >
    <div class="button-space" #tooltipChat="matTooltip" [matTooltip]="AS.appModes.includes(appModes.Chat) ? ('LABELS.DISABLECHAT' | translate) : ('LABELS.ENABLECHAT' | translate)">
      <button class="no-border-no-background-button"
        [matBadge]="AS.unreadMessage" [matBadgeHidden]="!AS.unreadMessage" matBadgePosition="above after" matBadgeColor="warn"
        aria-label="Chat" (click)="changeMode(appModes.Chat, tooltipChat)"
        [disabled]="AS.commandsDisabled || !AS.session.config.chat">
          <span class="font-icon-button material-symbols-outlined">chat</span>
      </button>
    </div>
    <div [ngClass]="AS.appModes.includes(appModes.Chat) ? 'underline-space-white': 'underline-space-blue' "></div>
  </div>
  <div class="single-button">
    <div class="button-space" #tooltipPhoto="matTooltip" matTooltipClass="tooltip-class" [matTooltip]="AS.appModes.includes(appModes.Photo) ? ('LABELS.DISABLEPHOTO' | translate) : ('LABELS.ENABLEPHOTO' | translate)">
      <button class="no-border-no-background-button" aria-label="Photo" (click)="changeMode(appModes.Photo, tooltipPhoto)"
        [matBadge]="AS.unseenImages" [matBadgeHidden]="!AS.unseenImages || config.isCaller" matBadgePosition="above after" matBadgeColor="warn"
        [disabled]="AS.commandsDisabled  || !AS.session.config.customerAttachments">
          
        <span *ngIf="config.isReceiver || config.isGuest" class="font-icon-button material-symbols-outlined">collections</span>
        <span *ngIf="config.isCaller" class="font-icon-button material-symbols-outlined">photo_camera</span>
      </button>
    </div>
    <div [ngClass]="AS.appModes.includes(appModes.Photo) ? 'underline-space-white': 'underline-space-blue' "></div>
  </div>
  
  <div class="single-button">
    <div class="button-space" #tooltipVideo="matTooltip" [matTooltip]="(AS.appModes.includes(appModes.Video) ? ( !config.isCaller ? 'LABELS.DISABLE_VIDEO_SECTION': 'LABELS.DISABLEVIDEO' ) : (!config.isCaller ? 'LABELS.ENABLE_VIDEO_SECTION':'LABELS.ENABLEVIDEO')) | translate">
      <button class="no-border-no-background-button"  aria-label="Video" color="primary" (click)="changeMode(appModes.Video, tooltipVideo);"
        [disabled]="!(config.partecipantsStatus$ | targetPresence) || AS.phoneStatus == phoneStatuses.RINGING || !AS.isRegistered
          || AS.phoneStatus == phoneStatuses.REMOTE_RINGING || AS.commandsDisabled  || !AS.session.config.video">

          <!-- Icona per Receiver/Operatore -->
          <span *ngIf="config.isReceiver || config.isGuest" class="font-icon-button material-symbols-outlined"
            [style.color]="AS.phoneStatus == phoneStatuses.TALKING || config.otherPartecipantsOnCall.length > 0 ? 'var(--status-azure)!important' : ''">
            contact_emergency
          </span>

          <!-- Icona per Caller/Guest -->
          <span *ngIf="config.isCaller" class="font-icon-button material-symbols-outlined"
            [style.color]="AS.videoEnabled && AS.phoneStatus == phoneStatuses.TALKING ? 'crimson!important': ''">
            videocam
          </span>
      </button>
    </div>
    <div [ngClass]="AS.appModes.includes(appModes.Video) ? 'underline-space-white': 'underline-space-blue' "></div>
  </div>

  <div class="single-button" *ngIf="config.isCaller">
    <div class="button-space" #tooltipMic="matTooltip" [matTooltip]="(AS.microphoneEnabled ? 'LABELS.DISABLEMIC' : 'LABELS.ENABLEMIC') | translate">
      <button class="no-border-no-background-button" aria-label="Phone" (click)="toggleMic(tooltipMic)"
        [disabled]="AS.commandsDisabled || AS.phoneStatus == phoneStatuses.RINGING || AS.phoneStatus == phoneStatuses.REMOTE_RINGING || !AS.isRegistered
          || !(config.partecipantsStatus$ | targetPresence) || AS.availableDevices.audioInputs.length == 0 || !AS.session.config.audio">
          <span *ngIf="AS.microphoneEnabled" class="font-icon-button material-symbols-outlined" [style.color]="AS.microphoneEnabled ? 'crimson!important': ''">mic</span>
          <span *ngIf="!AS.microphoneEnabled" class="font-icon-button material-symbols-outlined">mic_off</span>
      </button>
    </div>
  </div>

  <div class="single-button" *ngIf="config.isCaller">
    <div class="button-space" #tooltipHome="matTooltip" [matTooltip]="'LABELS.BACKMAP' | translate" style="margin-right: 30px;">
      <button class="no-border-no-background-button" aria-label="Photo" (click)="exit(tooltipHome)"
        [disabled]="AS.commandsDisabled || !AS.session.config.localization">
        <span class="font-icon-button material-symbols-outlined">home</span>
      </button>
    </div>
  </div>

  <div *ngIf="config.isGuest && config.actualWidth < config.minGuestWidth" class="menu-panel-button">
    <app-menu (showSessionInfo)="showGuestSessionInfo($event)" (showCitizenInfo)="showGuestCitizenInfo($event)" [showMenuGuest]="true"></app-menu>
  </div>


  <div class="single-button media-buttons" *ngIf="config.isReceiver || config.isGuest" >
    <div class="button-space" #tooltipEnableVid="matTooltip" [matTooltip]="(AS.videoEnabled ? 'LABELS.DISABLEVIDEO'  : 'LABELS.ENABLEVIDEO') | translate">
      <button class="no-border-no-background-button"  aria-label="Video" color="primary" (click)="toggleLocalStream(tooltipEnableVid)"
        [disabled]="!(config.partecipantsStatus$ | targetPresence) || !config.iamOnCall">
          <span class="font-icon-button material-symbols-outlined" [style.color]="AS.videoEnabled ? 'crimson!important': ''">videocam</span>
      </button>
    </div>
    <div class="button-space" #tooltipEnableMic="matTooltip" [matTooltip]="AS.microphoneEnabled ? ('LABELS.DISABLEMIC' | translate) : ('LABELS.ENABLEMIC' | translate)">
      <button class="no-border-no-background-button" aria-label="Phone" (click)="toggleMic(tooltipEnableMic)"
        [disabled]="!(config.partecipantsStatus$ | targetPresence) || !config.iamOnCall">
          <span *ngIf="AS.microphoneEnabled" class="font-icon-button material-symbols-outlined" [style.color]="AS.microphoneEnabled ? 'crimson!important': ''">mic</span>
          <span *ngIf="!AS.microphoneEnabled" class="font-icon-button material-symbols-outlined">mic_off</span>
      </button>
    </div>
  </div>



</div>
